/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import React from 'react'
import {
  captionLarge,
  captionSmall,
  captionXSmall,
  heading1,
  heading2,
  heading3,
  heading4,
  heading5,
  heading6,
  paragraphMedium,
  paragraphSmall,
  paragraphXSmall,
  weightBold,
  weightMedium,
  weightRegular,
  weightSemiBold,
} from 'src/components/css'

type TextProps = {
  children?: React.ReactNode
  variant?:
    | 'heading1'
    | 'heading2'
    | 'heading3'
    | 'heading4'
    | 'heading5'
    | 'heading6'
    | 'paragraphMedium'
    | 'paragraphSmall'
    | 'paragraphXSmall'
    | 'captionLarge'
    | 'captionSmall'
    | 'captionXSmall'
  weight?: 'regular' | 'medium' | 'bold' | 'semiBold'
  color?: string
  style?: string
}

const Text = ({ variant, weight, color, style, children }: TextProps) => {
  return (
    <p
      css={css`
        ${style && style}
        ${variant === 'heading1' && heading1}
        ${variant === 'heading2' && heading2}
        ${variant === 'heading3' && heading3}
        ${variant === 'heading4' && heading4}
        ${variant === 'heading5' && heading5}
        ${variant === 'heading6' && heading6}
        ${variant === 'paragraphMedium' && paragraphMedium}
        ${variant === 'paragraphSmall' && paragraphSmall}
        ${variant === 'paragraphXSmall' && paragraphXSmall}
        ${variant === 'captionLarge' && captionLarge}
        ${variant === 'captionSmall' && captionSmall}
        ${variant === 'captionXSmall' && captionXSmall}
        ${weight === 'regular' && weightRegular}
        ${weight === 'medium' && weightMedium}
        ${weight === 'bold' && weightBold}
        ${weight === 'semiBold' && weightSemiBold}
        ${color && `color: ${color}`}
      `}
    >
      {children}
    </p>
  )
}

export default Text
